import { TrialMatchListPage } from "@/features/match/pages/TrialMatchList";
import React from "react";

const TrialMatchList = () => {
  return <TrialMatchListPage />;
};

export default TrialMatchList;
